<template>
<el-table-wrapper :style="fitHeight ? { height: '100%' } : null" :fit-height="fitHeight" ref="objTable" :data="data" :total="total" :columns="columns" :show-search-tool="showSearchTool" remote pagination
  :show-custom-header="showCustomHeader" @condition-change="onConditionChange" @selection-change="onSelectionChange">
  <template slot-scope="scope" slot="interface-slot">
    <i class="el-icon-search" style="cursor: pointer" @click="onClickInterfaceButton(scope.row)" />
  </template>
</el-table-wrapper>
</template>

<script>
import { isEmpty, cloneDeep } from 'lodash';
import { columnDefault, physicalObjTableColumns } from '@/constants/table';

export default {
  name: 'WPhysicalObjTable',
  props: {
    params: {
      type: Object,
      default: () => {},
    },
    showCustomHeader: {
      type: Boolean,
      default: false,
    },
    showSearchTool: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
    },
    fitHeight: {
      type: Boolean,
    },
    data: {
      type: Array,
      default: () => {},
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tableParams: {},
      columnDefault,
      physicalObjTableColumns,
      columns: [],
    };
  },
  watch: {
    params(to, from) {
      if (!isEmpty(to) && !isEmpty(to.params) && !isEmpty(to.columns)) {
        if (isEmpty(from) || to.params.managetypeId !== from.params.managetypeId || to.params.managetypeKey !== from.params.managetypeKey) {
          // TODO columns를 변경하더라도 label이 변경되지 않는 문제있어 빈 columns을 먼저 주고 관리 구분에 맞는 컬럼을 설정하도록 함.
          // v-for에서 재사용으로 인한 문제로 파악되며 근본적인 해결책을 찾을 경우 해당 로직 수정 필요
          this.columns = [];
          this.$refs.objTable.clearFilter();
          this.$nextTick(() => {
            const managetypeId = to.params.managetypeId;
            if (managetypeId === 'NMS') {
              const netdeviceColumns = cloneDeep(to.columns);
              netdeviceColumns.push({
                label: '인터페이스',
                width: 100,
                align: 'center',
                scopedSlot: 'interface-slot',
              });
              this.columns = netdeviceColumns;
            } else {
              this.columns = to.columns;
            }
          });
        }
        this.loadData();
      }
    },
  },
  methods: {
    /**
     * 물리 그룹 관리 대상 데이터를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      const params = {
        ...this.params.params,
        ...this.$refs.objTable.getParameter(),
      };
      this.$emit('load', params);
    },
    /**
     * 테이블 조건 변경 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onConditionChange() {
      this.loadData();
    },
    /**
     * 테이블 선택 변경 이벤트 핸들러
     * @author Ju
     * @param  {[type]} selection [description]
     * @return {[type]}           [description]
     */
    onSelectionChange(selection) {
      this.$emit('selection-change', selection);
    },
    /**
     * 선택된 데이터 배열 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getSelection() {
      return this.$refs.objTable.getTable().selection;
    },
    /**
     * 테이블 행 선택을 토글한다.
     * @author Ju
     * @param  {[type]} rows [description]
     * @return {[type]}      [description]
     */
    toggleRowSelection(rows) {
      rows.forEach((row) => {
        this.$refs.objTable.getTable().toggleRowSelection(row);
      });
    },
    /**
     * 모든 행 선택을 해제한다.
     * @author Ju
     * @return {[type]} [description]
     */
    clearSelection() {
      this.$refs.objTable.getTable().clearSelection();
    },
    onClickInterfaceButton(row) {
      this.$emit('on-click-interfae-button', row);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/LogicalGroupSettings/components/PhysicalObjTable.vue